import {Boards} from './boards.js';
import {Template} from './Template.js';

export class BoardList extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Template(`BoardList`);
	}
	init() {
		if (document.readyState===`loading`) {
			document.addEventListener(`DOMContentLoaded`, ()=>this.init());
			return;
		}
		this.inited = true;
		[this.el, this.$] = Template(`BoardList`);
		this.appendChild(this.el);
		console.log(`Boards = `, Boards);
		Boards.API().Boards().then( js=> {			
			console.log(`Got boards `, js);
			js.forEach(board => {
				if (board.status=='publish') {
					const b = document.createElement(`board-board`);
					b.setAttribute(`board-id`, board.id);
					b.setAttribute(`title`, board.title.rendered);
					this.$.list.appendChild(b);
				}
			});
		});
		if (this.getAttribute(`is-admin`)=='yes') {
			this.classList.add(`admin`);
		}
	}
	connectedCallback() {
		if (!this.inited) this.init();
	}	
}
customElements.define(`board-list`, BoardList);